<template>
  <b-modal
    ref="addServiceModal"
    size="lg"
    centered
    title="Dodaj warstwę"
    :visible="addLayerFromServiceWindowVisible"
    @hidden="hide"
    @show="onShow"
  >
    <b-form>
      <b-alert
        variant="danger"
        :show="
          noSelectedService ||
            noServiceKind ||
            noServiceUrl ||
            noSelectedLayers ||
            noSelectedLayerName ||
            wfsLayerGeometryTypeIsEmpty
        "
        ><strong>Uwaga.</strong> Formularz zawiera błędy.</b-alert
      >
      <b-alert variant="warning" :show="showNoLayersWarning"
        ><strong>Uwaga.</strong> Wybrana usługa nie posiada przypisanych
        warstw.</b-alert
      >
      <b-alert variant="danger" :show="showApiWarning"
        ><strong>Błąd.</strong> Wystąpił błąd połączenia. Warstwy nie zostały
        pobrane.</b-alert
      >
      <b-alert variant="info" :show="wfsGeometryTypeFetchInProgress"
        ><strong>Informacja.</strong> Trwa pobranie typu geometrii.</b-alert
      >
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        label="Typ usługi"
        label-for="service-type"
      >
        <b-form-radio-group
          id="service-type"
          v-model="systemService"
          :options="options"
        ></b-form-radio-group>
      </b-form-group>
      <div class="mb-3">
        <div v-show="systemService">
          <b-form-row v-show="noSelectedService">
            <b-col offset-md="3" md="7">
              <small class="text-danger">Należy wybrać usługę.</small>
            </b-col>
          </b-form-row>
          <b-form-group
            horizontal
            :label-cols="3"
            breakpoint="md"
            label="Wybierz usługę z listy"
            label-for="service"
          >
            <b-form-select
              id="service"
              v-model="service"
              :options="services"
              :state="noSelectedService ? false : null"
            ></b-form-select>
          </b-form-group>
        </div>
        <div v-show="!systemService">
          <b-form-row v-show="noServiceKind">
            <b-col offset-md="3" md="7">
              <small class="text-danger">Należy wybrać rodzaj usługi.</small>
            </b-col>
          </b-form-row>
          <b-form-group
            horizontal
            :label-cols="3"
            breakpoint="md"
            label="Wybierz rodzaj usługi"
            label-for="service-kind"
          >
            <b-form-select
              id="service-kind"
              v-model="serviceKind"
              :options="serviceKinds"
              :state="noServiceKind ? false : null"
            ></b-form-select>
          </b-form-group>
          <b-form-row v-show="noServiceUrl">
            <b-col offset-md="3" md="7">
              <small class="text-danger">Należy podać adres usługi.</small>
            </b-col>
          </b-form-row>
          <b-form-group
            horizontal
            :label-cols="3"
            breakpoint="md"
            label="Własny adres usługi"
            label-for="service-url"
          >
            <b-form-textarea
              id="service-url"
              v-model="serviceUrl"
              :rows="2"
              :no-resize="true"
              :state="noServiceUrl ? false : null"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <b-form-row>
          <b-col offset-md="3" md="9">
            <b-btn variant="primary" class="col-md-12" @click="fetchLayers">
              Pobierz listę warstw
            </b-btn>
          </b-col>
        </b-form-row>
      </div>
      <b-form-row v-show="noSelectedLayers">
        <b-col offset-md="3" md="7">
          <small class="text-danger"
            >Należy wybrać co najmniej jedną warstwę.</small
          >
        </b-col>
      </b-form-row>
      <b-form-row v-show="wfsLayerGeometryTypeIsEmpty">
        <b-col offset-md="3" md="7">
          <small class="text-danger"
            >Wybrana warstwa nie ma przypisanego typu geometrii.</small
          >
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        label="Warstwa"
        label-for="layer"
      >
        <div class="p-0" :class="{ 'has-error': noSelectedLayers }">
          <multiselect
            v-model="selectedLayers"
            :options="layers"
            :multiple="maxLayersNumber > 1"
            :close-on-select="maxLayersNumber === 1"
            :hide-selected="true"
            :searchable="true"
            select-label="Kliknij aby wybrać"
            selected-label="Wybrano"
            deselect-label="Kliknij aby usunąć"
            placeholder="Wybierz warstwy"
            :custom-label="customLabel"
            track-by="value"
            :show-no-result="true"
          >
            <template slot="noResult">
              Nie znaleziono elementów
            </template>
          </multiselect>
        </div>
      </b-form-group>
      <b-form-row v-show="noSelectedLayerName">
        <b-col offset-md="3" md="7">
          <small class="text-danger">Należy podać nazwę warstwy.</small>
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        label="Nazwa"
        label-for="name"
      >
        <b-form-input
          id="name"
          maxlength="66"
          v-model="name"
          :state="noSelectedLayerName ? false : null"
        ></b-form-input>
      </b-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn variant="primary" @click="addLayer" :disabled="fetchingLayers">
        <span v-show="layerSubmitting">
          <icon name="circle-notch" spin />
        </span>
        <span v-show="!layerSubmitting">
          Dodaj
        </span>
      </b-btn>
      <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
    </div>
    <loading-overlay
      :active="fetchingLayers || wfsGeometryTypeFetchInProgress"
      :is-full-page="false"
    ></loading-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { FETCH_ALL_LAYERS } from '../store/actions.type';
import {
  WINDOW_ADD_LAYER_FROM_SERVICE_HIDE,
  WINDOW_API_ERROR_SHOW
} from '../store/mutations.type';
import { Api as ApiMapServices } from '../api/api-uslugi-mapowe';
import { Api as LayersApi } from '../api/api-warstwy';
import LoadingOverlay from 'vue-loading-overlay';

export default {
  name: 'AddLayerFromServiceWindow',
  components: {
    LoadingOverlay
  },
  data: function() {
    return {
      systemService: true,
      options: [
        { text: 'Usługa systemowa', value: true },
        { text: 'Własna usługa', value: false }
      ],
      service: null,
      services: [],
      selectedLayers: [],
      layers: [],
      name: '',
      serviceKind: '',
      serviceKinds: [
        { text: 'WCS', value: 'wcs' },
        { text: 'WFS', value: 'wfs' },
        { text: 'WMS', value: 'wms' },
        { text: 'WMTS', value: 'wmts' }
      ],
      serviceUrl: '',
      noSelectedService: false,
      noServiceKind: false,
      noServiceUrl: false,
      fetchingLayers: false,
      noSelectedLayers: false,
      noSelectedLayerName: false,
      layersListFetched: false,
      showNoLayersWarning: false,
      showApiWarning: false,
      layersInfoVariant: '',
      showLayersInfo: false,
      layersInfoMessage: '',
      layerSubmitting: false,
      wfsLayerGeometryTypeIsEmpty: false,
      wfsGeometryTypeFetchInProgress: false
    };
  },
  computed: {
    ...mapGetters(['addLayerFromServiceWindowVisible']),
    maxLayersNumber() {
      if (
        this.serviceKind === 'wfs' ||
        (this.service && this.service.type === 'wfs')
      ) {
        return 1;
      }
      return 1000;
    },
    selectedLayer() {
      return this.selectedLayers instanceof Array
        ? this.selectedLayers[0]
        : this.selectedLayers;
    },
    wfsLayerGeometryType() {
      return this.selectedLayer ? this.selectedLayer.geometryType : null;
    }
  },
  watch: {
    systemService() {
      this.service = null;
      this.selectedLayers = [];
      this.layers = [];
      this.name = '';
      this.serviceKind = '';
      this.serviceUrl = '';
      this.noSelectedService = false;
      this.noServiceKind = false;
      this.noServiceUrl = false;
      this.fetchingLayers = false;
      this.noSelectedLayers = false;
      this.noSelectedLayerName = false;
      this.layersListFetched = false;
      this.showNoLayersWarning = false;
      this.showApiWarning = false;
    },
    service() {
      this.layers = this.selectedLayers = [];
    },
    serviceKind() {
      this.layers = this.selectedLayers = [];
    },
    serviceUrl() {
      this.layers = this.selectedLayers = [];
    }
  },
  methods: {
    async onShow() {
      this.systemService = true;
      this.services = [];
      this.service = null;
      this.selectedLayers = [];
      this.layers = [];
      this.name = '';
      this.serviceKind = '';
      this.serviceUrl = '';
      this.noSelectedService = false;
      this.noServiceKind = false;
      this.noServiceUrl = false;
      this.fetchingLayers = false;
      this.noSelectedLayers = false;
      this.noSelectedLayerName = false;
      this.layersListFetched = false;
      this.showNoLayersWarning = false;
      this.showApiWarning = false;

      const api = new ApiMapServices();

      try {
        const mapServices = await api.getUslugiMapowe({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null
        });
        this.services = mapServices.body.uslugi_mapowe.map(um => ({
          text: um.nazwa,
          value: { id: um.id, type: um.rodzaj, url: um.adres }
        }));
      } catch (e) {
        this.$store.commit(WINDOW_API_ERROR_SHOW);
      }
    },
    hide() {
      this.$store.commit(WINDOW_ADD_LAYER_FROM_SERVICE_HIDE);
    },
    async fetchLayers() {
      if (!this.validateServiceData()) {
        return;
      }

      const url = this.chooseUrl();

      if (url) {
        this.selectedLayers = [];
        this.layers = [];
        const api = new ApiMapServices();
        const serviceType = this.chooseServiceType();

        try {
          this.fetchingLayers = true;

          switch (serviceType) {
            case 'wfs':
              var apiLayers = await api.getWfs({
                url: url,
                wso2_id: this.contextEmail ? this.contextEmail : null,
                orgid: this.contextOrganizationId
                  ? this.contextOrganizationId
                  : null
              });
              break;
            case 'wms':
              var apiLayers = await api.getWms({
                url: url,
                wso2_id: this.contextEmail ? this.contextEmail : null,
                orgid: this.contextOrganizationId
                  ? this.contextOrganizationId
                  : null
              });
              break;
            case 'wcs':
              var apiLayers = await api.getWcs({
                url: url,
                wso2_id: this.contextEmail ? this.contextEmail : null,
                orgid: this.contextOrganizationId
                  ? this.contextOrganizationId
                  : null
              });
              break;
            case 'wmts':
              var apiLayers = await api.getWmts({
                url: url,
                wso2_id: this.contextEmail ? this.contextEmail : null,
                orgid: this.contextOrganizationId
                  ? this.contextOrganizationId
                  : null
              });
              break;
          }

          this.layers = apiLayers.body.warstwy.map(w => ({
            text: w.tytul,
            value: w.nazwa,
            geometryType: w.typ,
            pola: w.pola
          }));

          setTimeout(_ => {
            this.fetchingLayers = false;
            this.showLayersFetchInfo(true);
          }, 500);
        } catch (e) {
          setTimeout(_ => {
            this.fetchingLayers = false;
            this.showLayersFetchInfo(false);
          }, 500);
        }
      }
    },
    customLabel({ text }) {
      return text;
    },
    chooseUrl() {
      if (this.systemService && this.service) {
        return this.service.url;
      } else if (!this.systemService && this.serviceUrl) {
        return this.serviceUrl;
      }
    },
    chooseServiceType() {
      if (this.systemService && this.service) {
        return this.service.type;
      } else if (!this.systemService && this.serviceKind) {
        return this.serviceKind;
      }
    },
    validateServiceData() {
      this.noSelectedService = this.systemService && !this.service;
      this.noServiceKind = !this.systemService && !this.serviceKind;
      this.noServiceUrl = !this.systemService && !this.serviceUrl;

      return (
        !this.noSelectedService && !this.noServiceKind && !this.noServiceUrl
      );
    },
    validateLayerData() {
      this.noSelectedLayers = !this.selectedLayer;
      this.noSelectedLayerName = !this.name;

      this.wfsLayerGeometryTypeIsEmpty =
        this.chooseServiceType() === 'wfs' &&
        this.selectedLayer &&
        !this.wfsLayerGeometryType;

      return (
        !this.noSelectedLayers &&
        !this.noSelectedLayerName &&
        !this.wfsLayerGeometryTypeIsEmpty
      );
    },
    showLayersFetchInfo(success) {
      this.showNoLayersWarning = this.showApiWarning = false;

      if (success && this.layers && this.layers.length === 0) {
        this.showNoLayersWarning = true;
        this.layersListFetched = false;
      } else if (!success || !this.layers) {
        this.showApiWarning = true;
        this.layersListFetched = false;
      }
    },
    async addLayer(e) {
      e.preventDefault();

      if (
        this.chooseServiceType() === 'wfs' &&
        this.selectedLayer &&
        !this.wfsLayerGeometryType
      ) {
        this.wfsGeometryTypeFetchInProgress = true;
        this.selectedLayer.geometryType = await this.fetchWfsGeometryType(
          this.selectedLayer
        );
        this.wfsGeometryTypeFetchInProgress = false;
      }

      if (!this.validateServiceData() | !this.validateLayerData()) return;

      try {
        this.layerSubmitting = true;
        if (this.systemService) {
          await this.addLayerFromSystemService();
        } else {
          await this.addCustomLayer();
        }
        await this.$store.dispatch(FETCH_ALL_LAYERS, {
          useStoredSettings: false
        });
        this.$notify({
          type: 'success',
          title: 'Sukces!',
          text: 'Dodanie warstwy powiodło się.',
          duration: 2000
        });
      } catch (exception) {
        this.$notify({
          type: 'error',
          title: 'Uwaga!',
          text: 'Dodanie warstwy nie powiodło się.',
          duration: 2000
        });
      }

      this.layerSubmitting = false;
      this.$refs.addServiceModal.hide();
    },
    async addLayerFromSystemService() {
      const layersApi = new LayersApi();
      let selectedLayers = Array.isArray(this.selectedLayers)
        ? this.selectedLayers
        : [this.selectedLayers];
      let geometryType = undefined;
      if (selectedLayers && selectedLayers.length > 0) {
        geometryType = selectedLayers[0].geometryType;
      }

      await layersApi.postWarstwyUslugowe({
        body: {
          id_usluga: this.service.id,
          nazwa: this.name,
          warstwy: selectedLayers.map(sl => sl.text),
          skala_min: null,
          skala_max: null,
          typ_geometrii: geometryType,
          kompozycja_id: this.$store.getters.composition.id
        }
      });

      this.$store.dispatch(FETCH_ALL_LAYERS, { useStoredSettings: true });
    },
    async addCustomLayer() {
      const layersApi = new LayersApi();
      let selectedLayers = Array.isArray(this.selectedLayers)
        ? this.selectedLayers
        : [this.selectedLayers];
      let geometryType = undefined;
      if (selectedLayers && selectedLayers.length > 0) {
        geometryType = selectedLayers[0].geometryType;
      }
      await layersApi.postWarstwyUslugoweNowa({
        body: {
          adres: this.serviceUrl,
          nazwa: this.name,
          rodzaj: this.serviceKind,
          warstwy: selectedLayers.map(sl => sl.text),
          typ_geometrii: geometryType,
          kompozycja_id: this.$store.getters.composition.id
        }
      });
    },
    updateURLParameter(url, key, value) {
      if (url) {
        url = url.trim();
        var kvp = key + '=' + value;
        var urlList = url.split('?');
        var baseURL = urlList[0];
        var queryString = urlList[1];
        var temp = '';
        if (queryString) {
          if (!queryString.endsWith('&')) {
            queryString = queryString + '&';
          }
        }
        url = baseURL + '?' + (queryString || '') + kvp;
      }
      return url;
    },
    async fetchWfsGeometryType(selectedWfsLayer) {
      var apiUslugiMapowe = new ApiMapServices();
      let geometryType = null;
      let serviceUrl = this.systemService
        ? (this.service || {}).url
        : this.serviceUrl;

      if (serviceUrl && selectedWfsLayer && selectedWfsLayer.pola) {
        let field = selectedWfsLayer.pola.find(x => x.key !== 'gml_id');
        if (field) {
          try {
            let url = this.updateURLParameter(serviceUrl, 'sortBy', field.key);
            let response = await apiUslugiMapowe.getWfs({ url: url });
            let serviceLayers = response.body.warstwy.map(x => {
              return { value: x.nazwa, typGeometrii: x.typ };
            });
            let selectedWfsLayerWithSort = serviceLayers.find(
              x => selectedWfsLayer.value === x.value
            );
            if (selectedWfsLayerWithSort) {
              geometryType = selectedWfsLayerWithSort.typGeometrii;
            }
          } catch (e) {
            this.$notify({
              type: 'error',
              title: 'Uwaga!',
              text: 'Wystąpił błąd podczas pobrania typu geometrii.',
              duration: 2000
            });
          }
        }
      }
      return geometryType;
    }
  }
};
</script>

<style>
.has-error .multiselect__tags {
  border-color: #e40909;
}
</style>
